var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nyx-check-component"},[_c('div',{staticClass:"nyx-check-component__checked d-flex align-items-center justify-content-center",class:{
  'isChecked': _vm.isChecked
 }},[_c('i',{staticClass:"bi bi-check check-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }